// extracted by mini-css-extract-plugin
module.exports = {"downloadFormat":"Style_downloadFormat__890So","help":"Style_help__TMdo6"};